(function(){
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  // product offer
  var offer=$('[data-offer]');
  if(offer){
    var variants=JSON.parse($('[data-variants]',offer).textContent);
    var tiers=$$('.tier',offer), atc=$('#atc',offer), idIn=$('input[name="id"]',offer), price=$('#atcPrice',offer);
    var sticky=$('#stickyPrice'), stickyLbl=$('#stickyLabel');
    var money=function(c){return '$'+(c/100).toFixed(2)};
    function pick(id){
      tiers.forEach(function(t){t.classList.toggle('on',t.dataset.id===String(id))});
      var v=variants.filter(function(x){return String(x.id)===String(id)})[0]; if(!v) return;
      idIn.value=v.id; price.textContent=money(v.price);
      if(sticky){sticky.textContent=money(v.price)} if(stickyLbl){stickyLbl.textContent=v.title}
      atc.disabled=!v.available; atc.querySelector('.lbl').textContent=v.available?atc.dataset.label:atc.dataset.soldout;
    }
    tiers.forEach(function(t){t.addEventListener('click',function(){pick(t.dataset.id)})});
    var on=tiers.filter(function(t){return t.classList.contains('on')})[0]||tiers[0]; if(on) pick(on.dataset.id);
    // gallery
    var main=$('#gmain',offer);
    $$('#thumbs button',offer).forEach(function(b){b.addEventListener('click',function(){$$('#thumbs button',offer).forEach(function(x){x.classList.remove('on')});b.classList.add('on');main.style.opacity=0;setTimeout(function(){main.src=b.dataset.src;main.style.opacity=1},150)})});
  }
  // before/after show more
  var hidden=$$('.pair.hidden'), moreBtn=$('#moreBa');
  if(moreBtn){ if(!hidden.length) moreBtn.style.display='none'; moreBtn.addEventListener('click',function(){hidden.splice(0,6).forEach(function(p){p.classList.remove('hidden')}); if(!hidden.length) moreBtn.style.display='none';}); }
  // principles accordion (mobile)
  $$('.pcard.acc h3').forEach(function(h){h.addEventListener('click',function(){h.parentNode.classList.toggle('open')})});
  // sticky cta
  var st=$('#stickyCta'), off=$('#offer'), atcBtn=$('#atc');
  if(st&&off){
    var anchor=atcBtn||off;
    var upd=function(){var r=anchor.getBoundingClientRect();st.classList.toggle('show',r.bottom<0)};
    window.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
  }
  var yr=$('#yr'); if(yr) yr.textContent=new Date().getFullYear();
})();
